import React, { MouseEvent, useContext, useState } from "react";
import { Audience, addAudience, deleteAudience, updateAudience } from "../audience-api";
import { Modal, useModalHide } from "../components/Modal";
import { ClickShield } from "../table/Table";
import { SavingButton } from "../components/SavingButton";
import { AudienceContext, useAudienceContext } from "./AudienceStore";
import { useErrorAlert } from "../components/use-animation";
import { Alert } from "../components/Alert";
import { useConfirm } from "../components/Dialogs";
import { useAddToast } from "../components/Toasts";
import { ReactTooltip } from "tooltip";
import { useNavigate } from "react-router-dom";

function AudienceForm({audience}:{audience:Audience}){
    const [name, setName] = useState(audience.name)
    const [saving, setSaving] = useState(false)
    const {dispatch} = useContext(AudienceContext);
    const {audiences} = useAudienceContext();
    const hide = useModalHide();
    const [error, setError, shakeClass] = useErrorAlert();

    async function save(){
        if(!name)
            return setError("Escolha um nome");

        setSaving(true);
        
        try{
            const saved = audience.id ? await updateAudience({...audience, name}) : await addAudience({...audience, name});
            if(audience.id)
                dispatch({type:"updateAudience", payload: saved})
            else {
                dispatch({type:"setAudiences", payload: [...audiences, saved]})
            }

            hide();
        }catch(e){
            setError("Erro ao salvar público.")
            console.error(e);
        }
        
        setSaving(false);
    }

    return <>
        <input className="form-control mb-2" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome do público..." />
        {error != '' && <Alert content={error} className={`alert-danger ${shakeClass}`} onDismiss={() => setError('')} />}
        <div className="mt-4 text-end">
            <SavingButton onClick={save} saving={saving}>{audience.id ? 'Salvar Público' : 'Criar Público'}</SavingButton>
        </div>
    </>

}


export function AudienceItemActions({audience}:{audience:Audience}){
    const [show, setShow] = useState(false)
    const confirm = useConfirm(<>Deseja remover o público <b>{audience.name}</b>?</>, {buttonClass:"btn-danger", ok: "Apagar"})
    const {audiences} = useAudienceContext();
    const {dispatch} = useContext(AudienceContext);
    const addToast = useAddToast();
    const navigate = useNavigate();

    async function doDelete(){
        const ok = await confirm();
        if(!ok) return;
        dispatch({type: "setAudiences", payload: audiences.filter(a => audience.id != a.id)})
        await deleteAudience(audience);
        addToast("Público removido", 'bg-success');
    }

    function goTo(){
        dispatch({type:"setAudience", payload: audience})
        navigate(`./${audience.id}`)
    }

    return <ClickShield>
        <ReactTooltip className="me-2" tooltip={<>Importar e gerenciar contatos<br />(items da lista)</>}>
            <button className="btn btn-primary" onClick={goTo}><i className="fa fa-list"></i></button>
        </ReactTooltip>
        <ReactTooltip className="me-2" tooltip="Editar nome do público">
            <button className="btn btn-primary" onClick={() => setShow(true)}><i className="fa fa-pen-to-square"></i></button>
        </ReactTooltip>
        <ReactTooltip className="me-2" tooltip="Remover público">
            <button className="btn btn-danger" onClick={doDelete}><i className="fa fa-trash"></i></button>
        </ReactTooltip>
        {show && <Modal title={audience.name} onHide={() => setShow(false)}>
                <AudienceForm audience={audience} />
            </Modal>}
    </ClickShield>
}

export function AudienceAddButton(){
    const [show, setShow] = useState(false)
    

    return <>
        <button className="btn btn-primary" onClick={() => setShow(true)}>Adicionar Publico</button>
        {show && <Modal title="Novo Público" onHide={() => setShow(false)}>
                <AudienceForm audience={{name:"", id:0, numMembers: 0, created: null}} />
            </Modal>}
    </>
}